import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { DurationPickerUnitComponent } from './duration-picker-unit.component';
import { DurationPickerComponent } from './duration-picker.component';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';

@NgModule({
  declarations: [DurationPickerComponent, DurationPickerUnitComponent],
  imports: [CommonModule, FormsModule, NzInputNumberModule],
  exports: [DurationPickerComponent, DurationPickerUnitComponent]
})
export class DurationPickerModule {}
